// Content registry — bundles repo Markdown + assignment question sets so the
// SPA can render a lesson by its `body_ref` (the path stored on the lesson row).
//
// Content authoring is file-based per the build plan (Markdown/YAML in repo,
// rendered client-side, no CMS). Lesson rows carry a `body_ref` like
// "content/block-1.2.md"; we resolve that here.

// Eagerly import every Markdown file under /content as a raw string.
// Keys look like "/content/block-1.2.md".
const markdownModules = import.meta.glob('/content/**/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>;

/** Resolve a lesson `body_ref` (e.g. "content/block-1.2.md") to its Markdown. */
export function getMarkdown(bodyRef: string | null | undefined): string | null {
  if (!bodyRef) return null;
  const normalized = bodyRef.startsWith('/') ? bodyRef : `/${bodyRef}`;
  return markdownModules[normalized] ?? null;
}

export { assignments, getAssignment } from './assignments';
export type {
  AssignmentDef,
  AssignmentQuestion,
  AssignmentQuestionType,
} from './assignments';
